import { Activity } from "lucide-react";

export default function Logo({ compact = false }) {
  return (
    <div data-testid="alignexa-logo" className="flex items-center gap-3">
      <div className="relative">
        <span className="absolute inset-0 rounded-xl border border-[#00F0FF]/40 animate-pulse-ring" />
        <div className="glass rounded-xl p-2">
          <Activity className="w-4 h-4 text-[#00F0FF]" strokeWidth={2} />
        </div>
      </div>
      {!compact && (
        <div className="leading-none">
          <p className="font-display font-semibold text-lg tracking-tight text-white">
            Alignexa<span className="text-gradient-brand"> AI</span>
          </p>
          <p className="text-[9px] tracking-[0.4em] uppercase text-white/40 mt-1">
            Clinical Intelligence
          </p>
        </div>
      )}
    </div>
  );
}
